const ACTION_AI_MODEL_TYPES = {
  browseweb: ['text'],
  computeruse: ['text'],
  cmqverifydoctor: ['text'],
  oiiqverifynurse: ['text'],
  createfile: ['text'],
  createproject: ['text'],
  createdocx: ['text'],
  createpdf: ['text'],
  generatewidget: ['text', 'vision', 'audio'],
  generativeanswer: ['text', 'vision'],
  generativeanswerfile: ['text', 'vision'],
  deterministicanswer: ['text'],
  summarize: ['text', 'vision'],
  looptriggerflow: ['text'],
  validatereservation: ['text'],
  validatedoctorlicense: ['text'],
  weatherapi: ['text'],
  extractimagetotag: ['vision'],
  convertpdftodocx: ['vision'],
  documentlegalpdftodocx: ['text', 'vision'],
  convertpdftohtml: ['vision'],
  convertpdfimagetopdftext: ['text', 'vision'],
  rotatepdfimageocrpdf: ['vision'],
  searchandinsertimagetopdf: ['vision'],
  searchandinsertrichtexttopdf: ['vision'],
};

const ACTION_AI_MODEL_FIELDS = {
  text: 'aiTextModelId',
  vision: 'aiVisionModelId',
  audio: 'aiAudioModelId',
};

export const getActionAIModelTypes = (actionType, isPluginAction = false) => {
  const normalizedType = String(actionType || '').trim().toLowerCase();
  if (isPluginAction) {
    return ['text', 'vision'];
  }
  return ACTION_AI_MODEL_TYPES[normalizedType] || [];
};

export const normalizeActionAIModelSelections = (data = {}) => ({
  aiTextModelId: data?.aiTextModelId ? String(data.aiTextModelId) : '',
  aiVisionModelId: data?.aiVisionModelId ? String(data.aiVisionModelId) : '',
  aiAudioModelId: data?.aiAudioModelId ? String(data.aiAudioModelId) : '',
});

export const buildActionAIModelData = (actionType, selections = {}, isPluginAction = false) => {
  const normalizedSelections = normalizeActionAIModelSelections(selections);
  const modelData = {};

  getActionAIModelTypes(actionType, isPluginAction).forEach((modelType) => {
    const fieldName = ACTION_AI_MODEL_FIELDS[modelType];
    if (fieldName) {
      modelData[fieldName] = normalizedSelections[fieldName];
    }
  });

  return modelData;
};

export const getActionAIModelField = (modelType) => ACTION_AI_MODEL_FIELDS[modelType] || '';
